var _excluded = ["style", "allowMapMarker", "mapMarkerType", "onMarkerLocationChange", "markerStyle", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import OlMap from 'ol/Map';
import { default as React, Fragment, useCallback, useEffect } from 'react';
import { useOpenLayers } from '../openlayers-context';
import { getEvents, getOptions } from '../utils';
import CenterMarker from './CenterMarker';
import { MapTarget } from './Map.styles';
import { MapMarkerType } from './MapMarkerType';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';
var allMapEvents = {
  movestart: undefined,
  moveend: undefined,
  rendercomplete: undefined,
  renderstart: undefined,
  postrender: undefined,
  'change:view': undefined
};
var allMapOptions = {
  controls: undefined,
  layers: undefined,
  view: undefined,
  target: undefined
};

var Map = _ref => {
  var {
    style,
    allowMapMarker,
    mapMarkerType,
    onMarkerLocationChange,
    markerStyle,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    map,
    mapContainerRef,
    setMap,
    centerMarkerEventKey
  } = useOpenLayers();
  var memoizedProps = useDeepCompareMemoize(props);
  var memoizedMapOptions = useDeepCompareMemoize(getOptions(Object.assign(allMapOptions, memoizedProps)));
  var memoizedMapEvents = useDeepCompareMemoize(getEvents(allMapEvents, memoizedProps));
  useEffect(() => {
    var newMap = new OlMap(_objectSpread({
      controls: [],
      target: memoizedMapOptions.targetDiv || (mapContainerRef === null || mapContainerRef === void 0 ? void 0 : mapContainerRef.current)
    }, memoizedMapOptions));

    for (var eventName in memoizedMapEvents) {
      // TODO: This should not be any. Please fix.
      newMap.on(eventName, memoizedMapEvents[eventName]);
    }

    setMap === null || setMap === void 0 ? void 0 : setMap(newMap);
    return () => {
      for (var _eventName in memoizedMapEvents) {
        // TODO: This should not be any. Please fix.
        newMap.un(_eventName, memoizedMapEvents[_eventName]);
      }
    };
  }, [mapContainerRef, memoizedMapEvents, memoizedMapOptions, setMap]);
  var mapCenterMarkerEnabled = allowMapMarker && mapMarkerType === MapMarkerType.MapCenter;
  useEffect(() => {
    if (mapMarkerType && mapMarkerType !== MapMarkerType.MapCenter) {
      console.log("Map marker type ".concat(mapMarkerType, " is not implemented"));
    }
  }, [mapMarkerType]);
  var onMoveEnd = useCallback(evt => {
    if (!onMarkerLocationChange) return;
    var coordinates = evt.map.getView().getCenter();
    onMarkerLocationChange({
      coordinates
    });
  }, [onMarkerLocationChange]);
  useEffect(() => {
    if (!map || !centerMarkerEventKey) return;
    if (centerMarkerEventKey.current) map.un('moveend', centerMarkerEventKey.current.listener);
    centerMarkerEventKey.current = mapCenterMarkerEnabled && onMarkerLocationChange ? map.on('moveend', evt => onMoveEnd(evt)) : null;
  }, [map, centerMarkerEventKey, mapCenterMarkerEnabled, onMarkerLocationChange, onMoveEnd]);

  if (!mapContainerRef) {
    console.log('No container ref found. Check Map is the child of MapProvider.');
    return /*#__PURE__*/React.createElement(Fragment, null);
  }

  return /*#__PURE__*/React.createElement(MapTarget, {
    ref: mapContainerRef,
    "data-testid": "map-target",
    className: "web-maps-map",
    style: style
  }, mapCenterMarkerEnabled && /*#__PURE__*/React.createElement(CenterMarker, {
    markerStyle: markerStyle
  }), children);
};

export default Map;